import {createSlice} from '@reduxjs/toolkit';


const initialState = {
    selected : false,
}
const defaultCustomerSlice = createSlice({
    name:'defaultCustomer',
    initialState,
    reducers:{
        setSelected : (state, action)=>{
            state.selected = action.payload;
        }
    }
});

export const defaultCustomerActions = defaultCustomerSlice.actions;

export const defaultCustomerSelector = (state:any) => state?.defaultCustomer;

export default defaultCustomerSlice.reducer;





